import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';
import { CombinedErrorInternalObject } from '../prostudio.api-service.types';

export const getFileData = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  type: string;
  fileData: string;
  fileName: string;
  cb?: (data: string) => void;
} | void> => {
  if (event.type !== 'downloadScript' && event.type !== 'editScript') {
    return;
  }

  const { botName, customerId, draftVersion, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
  }

  const botId = `${customerId}.${botName}`;

  if (!draftVersion) {
    throwErrorWithId('Draft version is required (getFileData)');
  }

  const versionId = `${botId}.${draftVersion}`;

  const versionFileResponse = await urqlGql.getVersionFile({
    projectId,
    versionId,
    filePath: event.path,
  });

  const fileData = (
    versionFileResponse.error?.graphQLErrors[0]?.extensions
      ?.internal as CombinedErrorInternalObject
  )?.response.body.data.file_data;

  return {
    type: event.type,
    fileData,
    fileName: event.name,
    cb: event.cb,
  };
};
